"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Location = _interopRequireDefault(require("../geom/Location"));

var _LineString = _interopRequireDefault(require("../geom/LineString"));

var _IllegalArgumentException = _interopRequireDefault(require("../../../../java/lang/IllegalArgumentException"));

var _Point = _interopRequireDefault(require("../geom/Point"));

var _Polygon = _interopRequireDefault(require("../geom/Polygon"));

var _PointLocation = _interopRequireDefault(require("./PointLocation"));

var _BoundaryNodeRule = _interopRequireDefault(require("./BoundaryNodeRule"));

var _MultiPolygon = _interopRequireDefault(require("../geom/MultiPolygon"));

var _GeometryCollectionIterator = _interopRequireDefault(require("../geom/GeometryCollectionIterator"));

var _GeometryCollection = _interopRequireDefault(require("../geom/GeometryCollection"));

var _MultiLineString = _interopRequireDefault(require("../geom/MultiLineString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PointLocator =
/*#__PURE__*/
function () {
  function PointLocator() {
    _classCallCheck(this, PointLocator);

    PointLocator.constructor_.apply(this, arguments);
  }

  _createClass(PointLocator, [{
    key: "locateInPolygonRing",
    value: function locateInPolygonRing(p, ring) {
      if (!ring.getEnvelopeInternal().intersects(p)) return _Location.default.EXTERIOR;
      return _PointLocation.default.locateInRing(p, ring.getCoordinates());
    }
  }, {
    key: "intersects",
    value: function intersects(p, geom) {
      return this.locate(p, geom) !== _Location.default.EXTERIOR;
    }
  }, {
    key: "updateLocationInfo",
    value: function updateLocationInfo(loc) {
      if (loc === _Location.default.INTERIOR) this._isIn = true;
      if (loc === _Location.default.BOUNDARY) this._numBoundaries++;
    }
  }, {
    key: "computeLocation",
    value: function computeLocation(p, geom) {
      if (geom instanceof _Point.default) {
        this.updateLocationInfo(this.locateOnPoint(p, geom));
      }

      if (geom instanceof _LineString.default) {
        this.updateLocationInfo(this.locateOnLineString(p, geom));
      } else if (geom instanceof _Polygon.default) {
        this.updateLocationInfo(this.locateInPolygon(p, geom));
      } else if (geom instanceof _MultiLineString.default) {
        var ml = geom;

        for (var i = 0; i < ml.getNumGeometries(); i++) {
          var l = ml.getGeometryN(i);
          this.updateLocationInfo(this.locateOnLineString(p, l));
        }
      } else if (geom instanceof _MultiPolygon.default) {
        var mpoly = geom;

        for (var i = 0; i < mpoly.getNumGeometries(); i++) {
          var poly = mpoly.getGeometryN(i);
          this.updateLocationInfo(this.locateInPolygon(p, poly));
        }
      } else if (geom instanceof _GeometryCollection.default) {
        var geomi = new _GeometryCollectionIterator.default(geom);

        while (geomi.hasNext()) {
          var g2 = geomi.next();
          if (g2 !== geom) this.computeLocation(p, g2);
        }
      }
    }
  }, {
    key: "locateOnPoint",
    value: function locateOnPoint(p, pt) {
      var ptCoord = pt.getCoordinate();
      if (ptCoord.equals2D(p)) return _Location.default.INTERIOR;
      return _Location.default.EXTERIOR;
    }
  }, {
    key: "locateOnLineString",
    value: function locateOnLineString(p, l) {
      if (!l.getEnvelopeInternal().intersects(p)) return _Location.default.EXTERIOR;
      var seq = l.getCoordinateSequence();

      if (!l.isClosed()) {
        if (p.equals(seq.getCoordinate(0)) || p.equals(seq.getCoordinate(seq.size() - 1))) {
          return _Location.default.BOUNDARY;
        }
      }

      if (_PointLocation.default.isOnLine(p, seq)) {
        return _Location.default.INTERIOR;
      }

      return _Location.default.EXTERIOR;
    }
  }, {
    key: "locateInPolygon",
    value: function locateInPolygon(p, poly) {
      if (poly.isEmpty()) return _Location.default.EXTERIOR;
      var shell = poly.getExteriorRing();
      var shellLoc = this.locateInPolygonRing(p, shell);
      if (shellLoc === _Location.default.EXTERIOR) return _Location.default.EXTERIOR;
      if (shellLoc === _Location.default.BOUNDARY) return _Location.default.BOUNDARY;

      for (var i = 0; i < poly.getNumInteriorRing(); i++) {
        var hole = poly.getInteriorRingN(i);
        var holeLoc = this.locateInPolygonRing(p, hole);
        if (holeLoc === _Location.default.INTERIOR) return _Location.default.EXTERIOR;
        if (holeLoc === _Location.default.BOUNDARY) return _Location.default.BOUNDARY;
      }

      return _Location.default.INTERIOR;
    }
  }, {
    key: "locate",
    value: function locate(p, geom) {
      if (geom.isEmpty()) return _Location.default.EXTERIOR;

      if (geom instanceof _LineString.default) {
        return this.locateOnLineString(p, geom);
      } else if (geom instanceof _Polygon.default) {
        return this.locateInPolygon(p, geom);
      }

      this._isIn = false;
      this._numBoundaries = 0;
      this.computeLocation(p, geom);
      if (this._boundaryRule.isInBoundary(this._numBoundaries)) return _Location.default.BOUNDARY;
      if (this._numBoundaries > 0 || this._isIn) return _Location.default.INTERIOR;
      return _Location.default.EXTERIOR;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return PointLocator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return PointLocator;
}();

exports.default = PointLocator;

PointLocator.constructor_ = function () {
  this._boundaryRule = _BoundaryNodeRule.default.OGC_SFS_BOUNDARY_RULE;
  this._isIn = null;
  this._numBoundaries = null;

  if (arguments.length === 0) {} else if (arguments.length === 1) {
    var boundaryRule = arguments[0];
    if (boundaryRule === null) throw new _IllegalArgumentException.default("Rule must be non-null");
    this._boundaryRule = boundaryRule;
  }
};